"use client"

import { useRouter } from "@bprogress/next/app";
import { Button } from "@mui/material";
import { FunnelX } from "lucide-react";
import { usePathname, useSearchParams } from "next/navigation";
import { Fragment, useCallback } from "react";

export default function PlpRemoveFiltersButton() {
    const searchParams = useSearchParams()
    const pathname = usePathname();
    const router = useRouter()


    const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {

        const current = new URLSearchParams();
        const slug = searchParams.get('product_class_slug')
        if (slug) current.set('product_class_slug', slug)

        const search = current.toString();
        const query = search ? `?${search}` : "";

        router.push(`${pathname}${query}`, { scroll: false });
    }, [searchParams, pathname])


    return (
        <Fragment>
            <Button
                onClick={handleClick}
                variant="outlined"
                color="inherit"
                endIcon={<FunnelX />}
                sx={{
                    height: 58,
                    mr: 1,
                    minWidth: 180,
                    justifyContent: 'space-between',
                    // color: colors.grey[900]
                }}>
                حذف فیلتر های اعمال شده
            </Button>
        </Fragment>
    )
}
